document.addEventListener('DOMContentLoaded', function() {
    var languageSwitcher = document.querySelector('.language__switch-container');
    var languageIcon = document.querySelector('.language__switch-icon');

    languageSwitcher.addEventListener('mouseover', function() {
        // languageSwitcher.querySelector('.language__switch-dropdown').style.display = 'block';
        // add class active to .language__switch-icon
        languageSwitcher.classList.add('active');
    });

    languageSwitcher.addEventListener('mouseleave', function() {
        // languageSwitcher.querySelector('.language__switch-dropdown').style.display = 'none';
        // remove class active from
        languageSwitcher.classList.remove('active');
    });
});